import { render, staticRenderFns } from "./paihangbang.vue?vue&type=template&id=152667d0"
import script from "./paihangbang.vue?vue&type=script&lang=js"
export * from "./paihangbang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports